require('./contractSummary.scss');
// @ vendors
const classNames = require('classnames');
const { Map } = require('immutable');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// Local components
const UserAddress = require('../userAddress/userAddress');
// @ utilities
const {
    EVENT_CLICK,
    PROC_ADD_DOCUMENTATION,
    recordLink,
} = require('utilities/tagging');
const { generateAccountId } = require('utilities/APIParsingHelper');
// @ helpers
const contractBuilder = require('routes/contractsView/libs/contractBuilder');
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const { formatText, formatTextApi, FormattedText, getLanguage } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formatAmountObject, getPlainAmountObject, formatInterest } = require('utilities/currencyHelper');
// @ constants
const {
    ACCOUNT_INTERVENTION_AUTHORIZED_CODE,
    ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE,
    ACCOUNT_INTERVENTION_OWNER_CODE,
    ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE,
    ADD_DOCUMENTATION_BUTTON,
    ADDRESS_TYPE,
    AMOUNT_TARGET_TYPE,
    CARD_DESIGN,
    CARD_TYPE,
    FORMATTEDTEXT_TYPE,
    INTERVENER_TYPE,
    LINK_BUTTON_TYPE,
    PHONES_TYPE,
    RENEWABLE_DEPOSIT_TYPE,
    TEXT_TARGET_TYPE,
    TINTAE_TYPE,
} = require('constants/index');
const {
    COUNTRIES_CODES: { ES },
} = require("constants/countries");
const { FIOC_UPDATE_ACCOUNT_HIRING } = require('constants/flagBasedFeatures');
const INTERVENERS = {
    [ACCOUNT_INTERVENTION_OWNER_CODE]: 'interventionTypes-TITULAR',
    [ACCOUNT_INTERVENTION_AUTHORIZED_CODE]: 'interventionTypes-AUTORIZADO',
    [ACCOUNT_INTERVENTION_LEGAL_REPRESENTATIVE_CODE]: 'interventionTypes-REPRESENTANTE LEGAL',
    [ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE]: 'interventionTypes-APODERADO'
};

class ContractSummary extends React.Component {

    buildDetailsGrid(data) {
        const elements = data.map((row, index) => {
            const elementsRow = row.map((column, index) =>
                this.buildElement(column, index)
            );
            return (
                <div key={index} className="row">
                    {elementsRow}
                </div>
            );
        });

        return (
            <OKInformativeList>
                {elements}
            </OKInformativeList>
        );
    }

    getTinTae(country, tin, tae) {
        let tinTaeText, tinTaeVariables;
        if (country === ES) {
            tinTaeText =  tin === tae ? 'contractSummary-contractSummary_tae' : 'contractSummary-contractSummary_tinTae';
            tinTaeVariables =  tin === tae ? [formatInterest(tae, false, false)] : [formatInterest(tin, false, false), formatInterest(tae, false, false)];
        } else {
            tinTaeText = 'contractSummary-contractSummary_tin';
            tinTaeVariables = [formatInterest(tin, false, false)];
        }

        return {
            tinTaeText,
            tinTaeVariables
        }
    }

    /**
     * Renders details from a flow's successStep. column is an object with the following properties:
     * @param {Number} className    // sets className to item (use contract-summary__border-separator on left columns for a right border)
     * @param {Number} columns      // quantity of bootstrap columns
     * @param {Array} details       // array of items (divides the cell in multiple items)
     * @param {String} field        // field to get inside target
     * @param {String} label        // text to render inside item
     * @param {Number} offset       // offset for bootstrap
     * @param {Array} phones        // when type is PHONES_TYPE, renders phones in the array
     * @param {Boolean} pullRight   // sets pullRight style property
     * @param {String} source       // where it gets the data, defaults to cardDetails (must be according to source object below)
     * @param {String} target       // target to get inside source
     * @param {String} title        // text to render as a title
     * @param {String} to           // when type is LINK_BUTTON_TYPE, determines where the link points to
     * @param {String} type         // for the switch statement (renders different react components)
     */
    buildElement(column, index) {
        const {
            history,
            immAccount,
            immCommercialAds,
            immHireCardImageSelector,
            tealiumEventCategory,
            wizardState,
            saveProcessSelected,
            processOption,
            immProfileFields
        } = this.props;
        const cardDetails = wizardState.get('card_details');
        const source = {
            account: immAccount,
            cardDetails
        };
        const {
            className: columnClassName,
            columns,
            details,
            offset,
            pullRight
        } = column;

        const columnClassNames = classNames(
            `col-xs-${columns}`,
            {
                [columnClassName]: columnClassName,
            },
            {
                [`col-xs-offset-${offset}`]: offset
            },
            {
                'pull-right': pullRight
            }
        );
        const detail = details || [column];
        const elementColumn = detail.map((item, key) => {
            const {
                body,
                className: itemClassName,
                columns: columnsItem,
                field,
                extraContent,
                phones,
                source: itemSource,
                target: itemTarget,
                title,
                to,
                type
            } = item;
            const elementSource = source[itemSource || 'cardDetails'];
            const contentExtra = extraContent && contractBuilder[extraContent.buildExtraContent]();
            const itemClassNames = classNames(
                {
                    [`col-xs-${columnsItem}`]: details,
                    [`${itemClassName}`]: itemClassName
                }
            );
            let element;
            let text;

            switch (type) {
                case ADD_DOCUMENTATION_BUTTON:
                    const newAccount = wizardState.get('newAccount');
                    const addDocumentationEnabled = findElementbyId(cardDetails, 'tramitation_expedient', 'showAddDocumentation') &&
                        !findElementbyId(cardDetails, 'tramitation_expedient', 'addDocumentationError');

                    let uploadDocumentation;

                    if (!!newAccount && addDocumentationEnabled) {
                        const iban = {
                            codbban: newAccount.substring(4, newAccount.length),
                            controlDigit: newAccount.substring(2, 4),
                            country: newAccount.substring(0, 2),
                        };

                        const onClickUploadDocumentation = () => {
                            if (!!tealiumEventCategory) {
                                recordLink(tealiumEventCategory, PROC_ADD_DOCUMENTATION, EVENT_CLICK);
                            }
                            saveProcessSelected(processOption);

                            history.push(`/myprofile/accounts/${generateAccountId(iban)}/upload-documentation`);
                        }

                        uploadDocumentation = (
                            <OKButton
                                modifier="secondary"
                                onClick={onClickUploadDocumentation}
                            >
                                <FormattedText value="contractSummary-uploadDocumentation" />
                            </OKButton>
                        );
                    }

                    element = uploadDocumentation;
                    break;
                case ADDRESS_TYPE:
                    element = (
                        <span className="contract-summary__address">
                            <i className="contract-summary__address-icon icon icon-s-locacion"></i>
                            <UserAddress immProfileFields={immProfileFields} modifier="inline" />
                        </span>
                    );
                    break;
                case AMOUNT_TARGET_TYPE:
                    let amountObject;
                    let plainAmountObject;
                    let amountObjectFormatted;

                    if (Map.isMap(elementSource)) {
                        amountObject = elementSource.get(itemTarget);
                        plainAmountObject = getPlainAmountObject(amountObject);
                        amountObjectFormatted = formatAmountObject(plainAmountObject);
                    } else {
                        const immItemObject = findElementbyId(elementSource, itemTarget, undefined, false);
                        amountObject = {
                            amount: immItemObject.get('value'),
                            currency: immItemObject.get('format_type'),
                            decimalsLength: immItemObject.get('decimalsLength')
                        };

                        const isInterestRateAvailable = immItemObject.get('id') === 'tin' || immItemObject.get('id') === 'tae';
                        if (immItemObject.get('isLanguageString') && !immItemObject.get('formatNumber') && isInterestRateAvailable) {
                            amountObject.amount = <FormattedText value={immItemObject.get('value')}/>
                            amountObjectFormatted = amountObject;
                        } else {
                            amountObjectFormatted = formatAmountObject(amountObject);
                        }
                        plainAmountObject = amountObject;
                    }

                    element = (
                        <OneLineSymbolAmount
                            className="contract-summary__amount"
                            amountObject={plainAmountObject}
                            language={getLanguage()}
                            amountObjectFormatted={amountObjectFormatted}
                        />
                    );
                    break;
                case CARD_DESIGN:
                    const cardImage = findElementbyId(cardDetails, 'card_image', undefined, false);
                    const selectedCard = cardImage.get('value');

                    let cardImageContainer = null;

                    if (immHireCardImageSelector.get('fetchSuccess') && cardImage && selectedCard) {
                        const immImage = immHireCardImageSelector.getIn(['imagesById', selectedCard]);

                        if (!!immImage) {
                            cardImageContainer = (
                                <img
                                    className="contract-summary__card-image"
                                    src={immImage.get('url')}
                                />
                            );
                        }
                    }

                    element = cardImageContainer;

                    break;
                case CARD_TYPE:
                    const cardImg = findElementbyId(cardDetails, 'card_image', undefined, false);

                    if (cardImg && cardImg.get('value')) {
                        const imgSrc = immCommercialAds.getIn(['byId', cardImg.get('value'), 'fieldImageLarge', 'url']);
                        const extraImage = cardImg.get('extraImage');
                        let extraImageElement;

                        if (extraImage) {
                            const extraImageSrc = immCommercialAds.getIn(['byId', extraImage, 'fieldImageLarge', 'url']);
                            extraImageElement = (
                                <div className="contract-summary__extra-image-container">
                                    <img
                                        src={extraImageSrc}
                                        className="contract-summary__extra-image"
                                    />
                                </div>
                            )
                        }

                        element = (
                            <div className="contract-summary__image-container">
                                {extraImageElement}
                                <img src={imgSrc} />
                            </div>
                        );
                    }
                    break;
                case INTERVENER_TYPE:
                    const interveners = this.buildInterveners();
                    let juniorIntervener;

                    if (wizardState.getIn(['juniorData', 'documentNumber'])) {
                        const juniorPersonalData = findElementbyId(cardDetails, 'junior_form_personal_data');
                        const juniorName = findElementbyId(juniorPersonalData, 'input-safe-name');
                        const lastName = findElementbyId(juniorPersonalData, 'input-safe-last-name');
                        const secondLastName = findElementbyId(juniorPersonalData, 'input-safe-second-last-name');
                        const titularName = `${juniorName} ${lastName} ${secondLastName || ''}`;
                        juniorIntervener = (
                            <div>
                                <span className="contract-summary__intervener-name">{titularName}</span>
                                <span className="contract-summary__intervener-type"> ({formatText('interventionTypes-TITULAR')})</span>
                            </div>
                        );
                    }

                    element = (
                        <div>
                            {juniorIntervener}
                            {interveners}
                        </div>
                    );
                    break;
                case LINK_BUTTON_TYPE:
                    element = (
                        <OKButton
                            modifier="secondary"
                            targetBlank={true}
                            to={to}
                        >
                            <FormattedText value={title} />
                        </OKButton>
                    );
                    break;
                case PHONES_TYPE:
                    let phonesElement = [];
                    phones.forEach(phone => {
                        phonesElement.push(
                            <div className="col-xs-6">
                                <i className="contract-summary__phone-icon icon icon-s-llamar"></i>
                                <span>{phone}</span>
                            </div>
                        );
                    });
                    element = (<div className="row no-outside-gutter">{phonesElement}</div>);
                    break;
                case TEXT_TARGET_TYPE:
                    text = findElementbyId(elementSource, itemTarget, field);
                    break;
                case RENEWABLE_DEPOSIT_TYPE:
                    const item = findElementbyId(elementSource, itemTarget, field);
                    text = item ? formatText('contractSummary-mainDepositYes') : formatText('contractSummary-mainDepositNo');
                    break;
                case FORMATTEDTEXT_TYPE:
                    const elementItem = findElementbyId(elementSource, itemTarget, undefined, false);
                    text = <FormattedText value={elementItem.get('value')} injectedStrings={elementItem.get('injectedStringValues').toJS()}/>
                    break;
                case TINTAE_TYPE:
                    const originCountry = immProfileFields.get('originCountry');
                    const { tinTaeText, tinTaeVariables } = this.getTinTae(originCountry, findElementbyId(elementSource, 'tin'), findElementbyId(elementSource, 'tae'));
                    text = <FormattedText value={tinTaeText} injectedStrings={tinTaeVariables} />
                    break;
                default:
                    text = body;
            }
            return (
                <div key={`${index}${key}`} className={itemClassNames}>
                    <OKInformativeListItem
                        bodyText={text}
                        key={`${index}${key}`}
                        title={title}
                    >
                        {element}
                    </OKInformativeListItem>
                    {contentExtra}
                </div>
            );
        });

        return (
            <div key={`${index}`} className={columnClassNames}>
                {elementColumn}
            </div>
        );
    }

    buildInterveners() {
        const { wizardState } = this.props;
        const isJunior = wizardState.getIn(['juniorData', 'documentNumber']);
        return wizardState.get('interveners').map((intervener) => {
            const intervenerType =  intervener.get('type');
            let type;
            if(isJunior) {
                type = formatText('interventionTypes-REPRESENTANTE LEGAL');
            }
            else if (intervenerType) {
                type = formatTextApi('interventionTypes-type', intervenerType)
            }
            else {
                type = formatText(INTERVENERS[intervener.get('typeNumber')]);
            }
            return (
                <div key={intervener.get('name') + (intervener.get('type') || intervener.get('typeNumber'))}>
                    <span className="contract-summary__intervener-name">{intervener.get('name')}</span>
                    <span className="contract-summary__intervener-type"> ({type})</span>
                </div>
            );
        });
    }

    buildMessage(labels) {
        const { immProfileFields, seed, wizardState } = this.props;
        return labels.map(item => {
            const href = item.seed ? wizardState.getIn([seed, 'url']) : item.href;
            const injectedStrings = item.injectedString || PersonalDataHelper.getEmail(immProfileFields);
            let element = item.text && <FormattedText key={item.text} value={item.text} injectedStrings={[injectedStrings]} />
                || seed && wizardState.getIn([seed, 'title']);
            if (href) {
                element = (
                    <OKLink
                        key={item.text}
                        id={item.id}
                        target="_blank"
                        to={href}
                        modifier="inline"
                    >
                        {element}
                    </OKLink>
                );
            }

            return element;
        });
    }

    buildWarningMessage() {
        const { warningMessage } = this.props;

        return warningMessage.map((warning, index) => {
            const messageText = this.buildMessage(warning);
            const messageType = warning[0].type ? warning[0].type : "informative";
            return (
                <div className="contract-summary__message-section" key={index}>
                    <OKMessage type={messageType}>
                        {messageText}
                    </OKMessage>
                </div>
            );
        });
    }

    render() {
        const { details, extraMessage, instructions, wizardState, immFlagBasedFeatures, immProfileFields} = this.props;
        const detailsGrid = this.buildDetailsGrid(details);
        const message = this.buildWarningMessage();

        let extraMessageElement;
        const instructionsElement = instructions && (
            <section className="contract-summary__instructions-section">
                <div>
                    {contractBuilder[instructions](wizardState, immProfileFields.get('originCountry'), immFlagBasedFeatures.get(FIOC_UPDATE_ACCOUNT_HIRING))}
                </div>
            </section>
        );

        if (extraMessage) {
            extraMessageElement = (
                <div className="contract-summary__extra-message" type="warning">
                    <i className="icon icon-error contract-summary__extra-message-icon" />
                    <FormattedText value={extraMessage} className="contract-summary__extra-message-content" />
                </div>
            );
        }

        return (
            <article className="contract-summary">
                <section className="row no-gutter">
                    {extraMessageElement}
                    {detailsGrid}
                </section>
                <section className="contract-summary__mail-section">
                    {message}
                </section>
                {instructionsElement}
            </article>
        )
    }
}

ContractSummary.defaultProps = {
    warningMessage: [
        [{ text: 'contractSummary-mail' }]
    ]
};

ContractSummary.propTypes = {
    wizardState: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object,
    details: PropTypes.array.isRequired,
    immCommercialAds: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    warningMessage: PropTypes.array,
    extraMessage: PropTypes.string,
    instructions: PropTypes.string,
    seed: PropTypes.string,
    tealiumEventCategory: PropTypes.string,
    saveProcessSelected: PropTypes.func,
    processOption:PropTypes.object
};

module.exports = withRouter(ContractSummary);
